// extracted by mini-css-extract-plugin
export default {"layout":"layout___m8sMs","text":"text___fVbpr"};